import { FeatureFlag } from '@ps/web-core-enums';
import React from 'react';
import { useSelector } from 'react-redux';

import useFeature from '@swf/core/hooks/useFeature';
import { select } from '@swf/core/store';
import type { NavLink } from '@swf/poker';
import { MainNav } from '@swf/poker';

import {
  TXTCLI_Cash_Games,
  TXTCLI_Tournaments,
  TXTMOB_My_Clubs,
  TXTWCL_Public
} from './TopBar.messages.json';
import styles from './TopBar.scss';

const TopBar: React.FC = () => {
  const isPublicClubsEnabled = useFeature(FeatureFlag.PKRHomeGamesPublicClubSearch);
  const isMobileEmbedded = useSelector(select.device.isMobileEmbedded);
  const shouldAddPublicClubs = isPublicClubsEnabled && !isMobileEmbedded;

  const links: NavLink[] = [
    {
      translation: TXTMOB_My_Clubs,
      alias: 'homeGamesClubs'
    },
    {
      translation: TXTCLI_Tournaments,
      alias: 'homeGamesTournaments'
    },
    {
      translation: TXTCLI_Cash_Games,
      alias: 'homeGamesCashGames'
    }
  ];

  if (shouldAddPublicClubs) {
    links.splice(1, 0, {
      translation: TXTWCL_Public,
      alias: 'homeGamesPublicClubs'
    });
  }

  return (
    <div className={styles.topBar}>
      <div className={styles.inner}>
        <MainNav links={links} />
      </div>
    </div>
  );
};

export default TopBar;
